import en_us from './en_us';
import pt_br from './pt_br';

export default {
    en_us,
    pt_br
};